import { Injectable } from '@angular/core';
import {
	IntegrationTypeDomain,
	IntegrationDomain,
	IntegrationListingViewModel,
	CreateIntegrationViewModel,
	EditIntegrationViewModel,
	IntegrationListingViewModelContainer,

	//Exclusion
} from 'models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SafePipe } from 'shared/pipes/safe.pipe';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root',
})
export class IntegrationService {
	constructor(private http: HttpClient, private safePipe: SafePipe) {}

	public get(): Observable<IntegrationDomain> {
		return this.http.get<IntegrationDomain>('api/integrations/get');
	}

	public getIntegrationTypes(): Observable<IntegrationTypeDomain[]> {
		return this.http.get<IntegrationTypeDomain[]>('api/integrations/getintegrationtypes');
	}

	public getIntegrationsType(integrationTypeName: string): Observable<IntegrationDomain> {
		return this.http.get<IntegrationDomain>(`api/integrations/getintegrationstype/${integrationTypeName}`);
	}

	public createIntegration(createIntegrationViewModel: CreateIntegrationViewModel): Observable<string> {
		return this.http.post<string>('api/integrations/createintegration', createIntegrationViewModel);
	}

	public editIntegration(editIntegrationViewModel: EditIntegrationViewModel): Observable<string> {
		return this.http.post<string>('api/integrations/editintegration', editIntegrationViewModel);
	}

	public refreshListings(identifier: string): Observable<string> {
		return this.http.post<string>('api/integrations/refreshListings', identifier);
	}

	public getListings(): Observable<IntegrationListingViewModelContainer> {
		return this.http.get<IntegrationListingViewModelContainer>('api/integrations/getListings');
	}

	public saveListings(integrationListingViewModels: IntegrationListingViewModel[]): Observable<string> {
		return this.http.post<string>('api/integrations/saveListings', integrationListingViewModels);
	}

	public addIntegrationToQueue(userId: string): Observable<string> {
		return this.http.post<string>('api/integrations/addIntegrationToQueue', userId);
	}

	public testauthorisation(): Observable<void> {
		return this.http.get<void>('api/integrationauthorisations/test');
	}

	public reset(integrationId: number): Observable<number> {
		return this.http.post<number>('api/integrations/reset', integrationId);
	}

	public refreshKygListings(userId: string): Observable<void> {
		return this.http.post<void>('api/kyg/integrations/refreshListings', userId);
	}

	public clearIntegration(integrationId: number): Observable<void> {
		return this.http.post<void>('api/integrations/clearIntegration', integrationId);
	}

	public triggerStays(userId: string): Observable<string> {
		return this.http.post<string>('api/integrations/stayimport/trigger', userId);
	}

	public getHospitableConnectRedirectURL(): Observable<string> {
		return this.http.get<string>('api/HospitableConnect/getRedirectURL');
	}

	public createTheIntegrationViewModel(integration: IntegrationDomain): CreateIntegrationViewModel {
		const createIntegrationViewModel = new CreateIntegrationViewModel();
		createIntegrationViewModel.integrationTypeId = integration.integrationType.integrationTypeId;
		createIntegrationViewModel.authenticationType = integration.integrationType.authenticationType;
		createIntegrationViewModel.configuration = integration.authenticationConfiguration;
		createIntegrationViewModel.createdByCutOffDate = integration.createdByCutOffDate;
		createIntegrationViewModel.ignoreStaysOnFirstImport = integration.ignoreStaysOnFirstImport;
		createIntegrationViewModel.excludeAirbnb = integration.excludeAirbnb;
		createIntegrationViewModel.excludeDirect = integration.excludeDirect;
		createIntegrationViewModel.exclusionValues = integration.exclusionValues;
		createIntegrationViewModel.exclusion = integration.exclusion;
		return createIntegrationViewModel;
	}

	public createTheEditIntegrationViewModel(integration: IntegrationDomain): EditIntegrationViewModel {
		const editIntegrationViewModel = new EditIntegrationViewModel();
		editIntegrationViewModel.identifier = integration.identifier;
		editIntegrationViewModel.integrationTypeId = integration.integrationType.integrationTypeId;
		editIntegrationViewModel.authenticationType = integration.integrationType.authenticationType;
		editIntegrationViewModel.configuration = integration.authenticationConfiguration;
		editIntegrationViewModel.createdByCutOffDate = integration.createdByCutOffDate;
		editIntegrationViewModel.ignoreStaysOnFirstImport = integration.ignoreStaysOnFirstImport;
		editIntegrationViewModel.excludeAirbnb = integration.excludeAirbnb;
		editIntegrationViewModel.excludeDirect = integration.excludeDirect;
		editIntegrationViewModel.exclusionValues = integration.exclusionValues;
		editIntegrationViewModel.exclusion = integration.exclusion;

		return editIntegrationViewModel;
	}

	public getSafeUrl(path: string): SafeUrl {
		const safeUrl = this.safePipe.transform(path, 'url');
		return safeUrl;
	}

	public getConfigValue(integration: IntegrationDomain, key: string): string {
		let configValue = '';
		if (integration.isActive || integration.authenticationConfiguration) {
			const config: any = JSON.parse(integration.authenticationConfiguration);
			const pair = config.find(x => x.name === key);

			configValue = pair.value;
		}
		return configValue;
	}

	public getAuthCodeUrl(integrationTypeConfiguration: string): string {
		const authenticationConfiguration: any = JSON.parse(integrationTypeConfiguration);
		const pair = authenticationConfiguration.find(x => x.name === 'authUri');
		return pair.value;
	}

	//public toOption(value: AirBnb): AirBnbOption {
	//    const option = new AirBnbOption(true, value.isExcluded);
	//    return option;
	//}

	//public getAirBnbDisplayProperties(integration: IntegrationDomain): AirBnbOption{
	//    const exclusionTypes: ExclusionType[] = JSON.parse(integration.exclusions);

	//    const filtered = exclusionTypes.find(x => {
	//        return x.exclusionType === ExclusionName.AirBnb;
	//    });

	//    const airBnbDisplay = filtered === undefined
	//        ? new AirBnbOption(false, false)
	//        : this.toOption(filtered as AirBnb);

	//    return airBnbDisplay;
	//}

	//public getExclusionTypes(integration: IntegrationDomain): ExclusionType[] {

	//    const exclusionTypes: ExclusionType[] = JSON.parse(integration.exclusions);

	//    return exclusionTypes;
	//}

	//public findExclusion(exclusionTypes: ExclusionType[], exclusionToFind: Exclusion): ExclusionType {
	//    const filtered = exclusionTypes.find(x => {
	//        return x.exclusionType === exclusionToFind;
	//    });

	//    return filtered === undefined ? NotSupported : filtered;

	//}
}
